import { jsx } from "react/jsx-runtime";
import { Tooltip as MuiTooltip, styled } from "@mui/material";
import { forwardRef } from "react";
const TooltipBase = forwardRef((props, ref) => /* @__PURE__ */ jsx(
  MuiTooltip,
  {
    ref,
    ...props,
    slotProps: {
      popper: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -4]
            }
          }
        ]
      },
      ...props.slotProps
    }
  }
));
const Tooltip = styled(TooltipBase)``;
export {
  Tooltip
};
//# sourceMappingURL=Tooltip.js.map
